/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recover_Start_ErrorInputs */



/**
* | output |
* | --- |
* | "Something went wrong while starting recovery" |
*
* @param {Auth_Recover_Start_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recover_start_error = /** @type {((inputs?: Auth_Recover_Start_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recover_Start_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas ist beim Starten der Wiederherstellung schief gelaufen")
	return /** @type {LocalizedString} */ ("Something went wrong while starting recovery")
});